import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/homeData";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-foreground-200 text-foreground-500 text-xs font-medium rounded-lg tracking-wider uppercase">
            CATEGORIAS 2026
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mt-5 leading-tight">
            {t("categories.title")}{" "}
            <span className="text-foreground-300">{t("categories.titleHighlight")}</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-lg mx-auto">
            {t("categories.subtitle")}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 hover:bg-accent-50 hover:border-accent-200 transition-all duration-300 cursor-pointer group overflow-hidden"
            >
              {/* Category Image */}
              <div className="w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Info */}
              <div className="flex flex-col items-center gap-1.5 p-3 md:p-4">
                <span className="text-sm font-semibold text-foreground-800 group-hover:text-accent-700 transition-colors text-center leading-tight whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400 group-hover:text-accent-500 transition-colors">
                  {t("categories.viewProducts")}
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}